import { FormModel } from "components/Form";
import { Validators } from "utils/validators";


export const VariantFilterForm = (strings?: any, width = 4): FormModel[] => {
  return [
    {
      label: 'Variant name',
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators:[],
      responsive: { xs: 12 },
      required: false,
      width: width
    },
    {
      label: 'Variant Code',
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'string',
      variant: 'outlined',
      placeholder: '',
      field: 'variantCode',
      validators: [] ,
      responsive: { xs: 12 },
      required: false,
      width: width
    },
  ];
};
